import React from "react";
import { Link } from "react-router-dom";

const CouncilHeader = ({ data }) => {
  return (
    <div className="council-header">
      <div className="council-edit">
        <Link to="/edit-council-profile">
          <button>Edit Profile</button>
        </Link>
      </div>
      <div
        className="council-header-row"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="council-header-inner">
          <div className="user-photo">
            {data?.users[0]?.council_profile?.council_profile_photo && (
              <img
                src={data?.users[0]?.council_profile?.council_profile_photo}
                alt="user"
              />
            )}
          </div>
          <div class="council-header-right">
            <div class="user-name">
              <h1>
                {data?.users[0]?.council_profile?.name
                  ? data?.users[0]?.council_profile?.name
                  : ""}
              </h1>
              {data?.users[0]?.council_profile?.website ? (
                <Link
                  to={{ pathname: data?.users[0]?.council_profile?.website }}
                  target="_blank"
                >
                  Website
                </Link>
              ) : (
                <a href="javascript:void(0)">Website</a>
              )}
            </div>
            <ul class="user-info">
              <li>
                <label>STATE</label>
                <p>
                  {data?.users[0]?.council_profile?.state
                    ? data?.users[0]?.council_profile?.state
                    : ""}
                </p>
              </li>
              <li>
                <label>EMAIL</label>
                <p>
                  {data?.users[0]?.council_profile?.email
                    ? data?.users[0]?.council_profile?.email
                    : data?.users[0]?.email
                    ? data?.users[0]?.email
                    : " - "}
                </p>
              </li>
              <li>
                <label>Phone</label>
                <p>
                  {data?.users[0]?.council_profile?.mobile_number
                    ? data?.users[0]?.council_profile?.mobile_number
                    : " - "}
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div style={{ padding: "0px 30px 30px", backgroundColor: "#fff" }}>
          <label
            style={{
              fontSize: "12px",
              lineHeight: "14px",
              fontWeight: "600",
              marginBottom: "7px",
              color: "#696ae7",
              textTransform: "uppercase",
            }}
          >
            Description
          </label>
          <p
            style={{
              maxHeight: "37px",
              overflowX: "hidden",
              overflowY: "auto",
              fontSize: "14px",
              lineHeight: "17px",
              marginBottom: "0px",
            }}
          >
            {data &&
            data?.users[0] &&
            data?.users[0]?.council_profile?.description
              ? data?.users[0]?.council_profile?.description
              : " - "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouncilHeader;
